import Card from "components/card";
import Badge from "components/badge";
import { EMPLOYMENT_STATUS_COLORS } from "variables/constants";

const ProfileHeader = ({
    initials,
    fullName,
    designation,
    clientName,
    employmentStatus,
    variant = "dark",
    empCode,
}) => {
    const isDark = variant === "dark";

    return (
        <Card className="flex items-center gap-4 w-full">
            <span
                className={`relative flex w-20 h-20 shrink-0 rounded-full overflow-hidden border 
                    ${isDark 
                        ? "bg-white/20 backdrop-blur-xl border-white/30 text-white shadow-xl" 
                        : "bg-gray-200 border-gray-300 text-slate-800"
                    }`}
            >
                <span className="flex w-full h-full items-center justify-center font-semibold text-[24px]">
                    {initials}
                </span>
            </span>
            <div className="flex items-start justify-between w-full">
                <div className="min-w-0 flex-1">
                    <div
                        className="font-semibold leading-tight text-[20px]"
                    >
                        {fullName}
                    </div>

                    <span
                        className={`leading-tight mt-1 ${
                            isDark ? "text-cyan-100 text-[14px]" : "text-slate-600"
                        }`}
                    >
                        {designation} / {clientName}
                    </span>

                    <div className="mt-2">
                        <Badge color={EMPLOYMENT_STATUS_COLORS[employmentStatus]}>
                            <span>{employmentStatus}</span>
                        </Badge>
                    </div>
                </div>
                {empCode && (
                    <div className="inline-flex items-center justify-center px-2 py-0.5 rounded-xl border bg-white/20 backdrop-blur-xl transition-[color,box-shadow] text-cyan-100 text-sm font-medium shrink-0 w-fit">
                        <span>{empCode}</span>
                    </div>
                )}
            </div>
        </Card>
    );
};

export default ProfileHeader;
